import React from 'react';
import ButtonBase from './Button';

const defaultButtonStyle = {
  color: 'rgb(0,106,225)',
  backgroundColor: 'transparent',
  borderColor: 'rgb(0,106,225)',
  boxShadow: '0 0 0 2px rgba(0, 0, 0, 0)',
  '&:hover': {
    color: 'rgb(255,255,255)',
    backgroundColor: 'rgb(0,80,171)',
    borderColor: 'rgb(0,80,171)'
  },
  '&:focus': {
    boxShadow: '0 0 0 2px rgb(66,145,233)'
  },
  '&:active': {
    color: 'rgb(255,255,255)',
    backgroundColor: 'rgb(0,54,115)',
    borderColor: 'rgb(0,54,115)'
  },
  '&:active&:focus': {
    boxShadow: 'none'
  },
  '&:disabled': {
    color: 'rgb(154, 159, 166)',
    backgroundColor: 'rgb(217,220,222)',
    borderColor: 'rgb(217,220,222)',
    cursor: 'not-allowed'
  }
};

const primaryStyle = {
  ...defaultButtonStyle,
  color: 'rgb(255,255,255)',
  backgroundColor: 'rgb(0,106,225)'
};

const tertiaryStyle = {
  ...defaultButtonStyle,
  borderColor: 'transparent'
};

const DefaultButton = ({ children, style, ...rest }) => (
  <ButtonBase style={{ ...defaultButtonStyle, ...style }} {...rest}>
    {children}
  </ButtonBase>
);

DefaultButton.defaultStyle = {
  ...defaultButtonStyle
};

const PrimaryButton = ({ children, style, ...rest }) => (
  <ButtonBase style={{ ...primaryStyle, ...style }} {...rest}>
    {children}
  </ButtonBase>
);

PrimaryButton.defaultStyle = {
  ...primaryStyle
};

const TertiaryButton = ({ children, style, ...rest }) => (
  <ButtonBase style={{ ...tertiaryStyle, ...style }} {...rest}>
    {children}
  </ButtonBase>
);

TertiaryButton.defaultStyle = {
  ...tertiaryStyle
};

export { PrimaryButton, DefaultButton, TertiaryButton };
